export default {
  siteKey: '0x4AAAAAADzl7RLLN0RXYNG4',
}
